import { MapThresholdResults } from './MapThresholdResults';
import { MapThresholdParams } from './MapThresholdParams';
import { MapThresholdColors } from './MapThresholdColors';

export class MapConfig {
  ID: number;
  MapConfigName: string;

  //MapTypeThreshold = [];
  //MapTypeCallID = [];
  //MapTypeDeviceID = [];
  //MapTypeCallEvent = [];
  MapConfigTypeList = [];


  constructor() {
    this.MapConfigName = "";
    this.ID = 0;
  }
}

export class MapConfigTypes {
  ID: number;
  MapConfigID: number;
  MapTypeID: number;

  ResultID: number;
  ColumnID: number;
  AndORID: number;
  OperatorID: number;
  ThresholdValue: string;
  LegendName: string;
  VQuadDeviceID: string;
  Criteria: string;
  CECriteria: string;
  SearchOperatorID: number;

  ThresholdResult= [];
  ThresholdParams=[];
  ThresholdColors = [];
  CallIDResult = [];
  CallIDCriteria = [];
  CallIDColors = [];
  DeviceIDResult = [];
  DeviceIDCriteria = [];
  DeviceIDColors = [];
  CallEventDevices = [];
  CallEventCriteria = [];
  CallEventColors = [];

  constructor() {
    this.MapTypeID = 1;
    this.AndORID = 1;
    this.OperatorID = 1;
    this.ThresholdValue = "";
    this.LegendName = "";
    this.VQuadDeviceID = "";
    this.Criteria = "";
    this.CECriteria = "";
    this.SearchOperatorID = 6;
    this.ResultID = 1;
  }
}

export class AbsMapDisplayOptions {
  mapConfigID: number = 0;
  usePredefinedConfig: number=0;
  analysisEnabled: string = "ON";
  netTestEnabled: string = "ON";
  mobileInfoEnabled: string = "ON";
  errorEventsEnabled: string = "ON";
  displayOptionApplied: boolean = false;
  DisplayResultList = [];
  AnalysisList = [];
  NetTestList = [];
  MobileInfoList = [];
  ErrorEventList = [];
  TypeList = [];
  ResultList = [];
  PredefinedConfig :any;
}
